import moment from 'moment';
import CountryQuery from 'country-query';
import callApi from '../../util/apiCaller.js';

import { getOrderRequest } from '../Order/OrderActions.js';
import { isConditionChecked } from '../Cart/CartActions.js';
import { addError } from '../Error/ErrorActions.js';

import shippingFees from './shippings';

const PREPARATION_DAYS = [3, 5];

export const SET_SHIPPINGS = 'SET_SHIPPINGS';
export const REMOVE_SHIPPING = 'REMOVE_SHIPPING';

export function getShippingsRequest(refreshCache = false) {
    return dispatch => {
        return callApi(`shippings${refreshCache ? '?refreshCache=1' : ''}`).then(res => {
            res.shippings && dispatch(setShippings(res.shippings));
            return res.shippings;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

// throwOnError : le panier distingue un devis en échec d'une adresse sans transporteur.
export function getShippingMethodsRequest(address, weight = null, { throwOnError = false } = {}) {
	const payload = { address };
	if(weight != null && weight !== '') {
		payload.weight = weight;
	}
    return callApi('shippings/methods', 'post', payload).then(results => {
        return results;
    }).catch(err => {
        console.error(err);
        if(throwOnError) {
            throw err;
        }
        return [];
    });
}

export function editShippingRequest(shipping) {
    return dispatch => {
        return callApi('shipping/edit', 'post', { shipping }).then(res => {
            dispatch(getShippingsRequest(true));
            return res.shipping;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function removeShippingRequest(shippingId) {
    return dispatch => {
        return callApi('shipping/remove', 'delete', { shipping: { _id: shippingId } }).then(res => {
            dispatch(removeShipping(shippingId));
            return res.ok;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function getShippingLabelDocumentRequest(orderId, shippingId, expeditionId) {
	return dispatch => {
		return callApi(
			`order/${orderId}/shipping/${shippingId}/label/${expeditionId}/document`,
			'get',
		).catch(error => {
			dispatch(addError(error));
			return null;
		});
	};
}

export function getShippingLabelRequest(orderId, shippingId, expeditionId = '', options = { weight: null, shippingMethodId: null }) {
    return dispatch => {
        return callApi(`order/${orderId}/shipping/${shippingId}/label/${expeditionId || ''}`, 'post', options).then(res => {
            dispatch(getOrderRequest(orderId));
            return res;
        }).catch(error => {
            dispatch(addError(error));
            return error || null;
        });
    };
}

/** Méthodes Sendcloud réelles pour override admin d'étiquette (prix exact carburant inclus). */
export function getSendcloudMethodsRequest({ countryCode, weight, mode = 'home', carrier = null, postalCode = '' }) {
	return callApi('shippings/sendcloud/methods', 'post', {
		countryCode,
		weight,
		mode,
		carrier,
		postalCode,
	}).then(res => ({
		methods: res && Array.isArray(res.methods) ? res.methods : [],
		recommendedMethodId: res && res.recommendedMethodId != null ? res.recommendedMethodId : null,
	})).catch(err => {
		console.error(err);
		return { methods: [], recommendedMethodId: null };
	});
}

export function setShippingTrackingRequest(orderId, shippingId, expeditionId, trackingNumber) {
    return dispatch => {
        return callApi(`order/${orderId}/shipping/${shippingId}/trackingnumber/${expeditionId || ''}`, 'post', { trackingNumber }).then(res => {
            return res;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}

// Getters
export function getShippings(store) {
    return store.shippings.data;
}
export function getShipping(store, shippingId) {
    return store.shippings.data.find(shipping => shipping._id === shippingId);
}

export function getShippingByAddress(store, address, items = [], referral = null) {
    return address && store.shippings.data.find(shipping => isShippingApplicable(shipping, address, items, referral));
}

export function getShippingOption(shipping, option) {
    return (shipping.options || {})[option] || '';
}

export function isShippingApplicable(shipping, address, items = [], referral = null, options = {}) {
    // console.log('isShippingApplicable', shipping.identifier, shipping, address);

    // console.log('Country', address.countryCode && (shipping.countries || []).includes(address.countryCode) ? 'OK' : 'KO');

    // console.log('Postal code', (
    //     !shipping.exclude
    //     || (
    //         !address.postalCode.trim()
    //         || !shipping.exclude.postalCodes
    //         || shipping.exclude.postalCodes.split(',').every(postalCode => isAddressDepartmentAvailableForShipping(address.postalCode.trim(), postalCode))
    //     )
    // ) ? 'OK' : 'KO');

    // console.log('Shipping conditions', shipping.conditions);

	return address.countryCode && (shipping.countries || []).includes(address.countryCode.trim())
        && (
            !shipping.exclude
            || (
                !address.postalCode.trim()
                || !shipping.exclude.postalCodes
                || shipping.exclude.postalCodes.split(',').every(postalCode => isAddressDepartmentAvailableForShipping(address.postalCode.trim(), postalCode))
            )
        )
        && shipping.conditions.every(condition => isConditionChecked(condition, items, referral));
}

export function isAddressDepartmentAvailableForShipping(addressPostalCode, postalCode) {
    const jokerIndex = postalCode.indexOf('*') > 0 ? postalCode.indexOf('*') : postalCode.length;
    return addressPostalCode.substring(0, jokerIndex) !== postalCode.replace('*', '');
}

export function getShippingProviderData(shipping, key) {
	return ((shipping.providerData || []).find(providerData => providerData.key === key) || {}).value;
}

export function setShippings(shippings) {
    return {
        type: SET_SHIPPINGS,
        shippings,
    };
}

export function removeShipping(id) {
    return {
        type: REMOVE_SHIPPING,
        id,
    };
}

/// //// LEGACY //////
export function getAvailableCountries() {
    return CountryQuery.find('region', 'Europe').concat(CountryQuery.find('region', 'Americas')).concat(CountryQuery.find('region', 'Asia')).concat(CountryQuery.find('region', 'Africa')).concat(CountryQuery.find('region', 'Oceania')).concat(CountryQuery.find('region', 'Antarctic'));
}

export function getShippingInfo(countryCode) {
    return new Promise((resolve, reject) => {
        const data = shippingFees.find(shipping => shipping.countryCode.toUpperCase() === (countryCode || '').toUpperCase());
        console.log('Shipping fee found', data);
        if(data) {
            const today = moment.utc().add(1, 'day').format('d');
            const nextPreparationDay = PREPARATION_DAYS.find(day => today < day) || PREPARATION_DAYS[0];
            const preparationDays = Math.abs(today - nextPreparationDay) + 1;
            console.log('Preparation days', today, nextPreparationDay, preparationDays);
            const deliveryDateFrom = moment().add(preparationDays + data.deliveryTime, 'days');
            if(deliveryDateFrom.format('d') === '0') { // Dimanche
                deliveryDateFrom.add(1, 'day');
            }
            if(deliveryDateFrom.format('d') === '6') { // Samedi
                deliveryDateFrom.add(2, 'day');
            }
            const deliveryDateTo = deliveryDateFrom.clone().add(2, 'days');
            return resolve({
                ...data,
                deliveryDateFrom: deliveryDateFrom.format(),
                deliveryDateTo: deliveryDateTo.format(),
            });
        }
        reject(new Error('NotFound'));
    });
}
